import getStore from './store';

export default function getPhoneNumber() {
    const { textMessagingAccount } = getStore();
    if (!textMessagingAccount || !textMessagingAccount.NotificationPhoneNumberVerified) {
        return null;
    }

    const { NotificationPhoneNumber } = textMessagingAccount;
    if (NotificationPhoneNumber) {
        return NotificationPhoneNumber;
    }

    const { E164NotificationPhoneNumber } = textMessagingAccount;
    return E164NotificationPhoneNumber ? E164NotificationPhoneNumber.SignificantNumber : null;
}
